import BossModel from "@/models/BossModel";
import PersonalDetail from "@/models/WebsiteOffer/PersonalDetail";
import Proposal from "@/models/Proposal/Proposal";

export default class ProductRequest extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-offer/product-request';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteOfferProductRequests';

    static fields() {
        return {
            id: this.number(null).nullable(),
            website_offer_personal_detail_id: this.number(null).nullable(),
            start_date: this.attr(null),
            start_date_flexible: this.number(null).nullable(),
            trip_duration: this.number(null).nullable(),
            interests: this.attr(null),
            need_tickets: this.boolean(null),
            trip_notes: this.attr(null),
            created_at: this.attr(null),
            personal_detail: this.belongsTo(PersonalDetail, 'website_offer_personal_detail_id'),
            package_interests: this.attr(null),
            product_interests: this.attr(null),
        }
    }

    /**
     *
     * @param newProposal
     * @returns {Promise<Collections>}
     * @constructor
     */
    CreateProposal(newProposal) {
        return this.constructor.api().action(this.id + '/create-proposal')
            .create(newProposal, false).then((response) => {
                return Proposal.insert({data: response});
        });
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    PersonalDetail() {
        return this.getRelated('personal_detail');
    }

    productIntrests() {

        return this.getRelated('product_interests');
    }
}
